import { render, staticRenderFns } from "./FBanner.vue?vue&type=template&id=70b01637&scoped=true&"
import script from "./FBanner.vue?vue&type=script&lang=js&"
export * from "./FBanner.vue?vue&type=script&lang=js&"
import style0 from "./FBanner.vue?vue&type=style&index=0&id=70b01637&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b01637",
  null
  
)

export default component.exports